<app-button-list>
    <app-button [loading]="saving" (clickedEvent)="onSaveGrade()" [icon]="'save'">Save </app-button>
    <app-button [loading]="saving"
                (clickedEvent)="onProcessGradeSubmit()"
                [icon]="'arrow_upward'"
                [disabled]="!canSubmitGrade()"
                [matTooltip]="cannotSubmitGradeMessage()"
                [matTooltipClass]="'multiline-tooltip'">Submit Grades </app-button>
</app-button-list>
